import React, { useState } from "react";
import expandDown from "../assets/icons/Expand_down.svg";

const TermsConditionsPage = () => {
  const [expandedSections, setExpandedSections] = useState([]);

  const toggleSection = (index) => {
    setExpandedSections((prev) =>
      prev.includes(index)
        ? prev.filter((section) => section !== index)
        : [...prev, index]
    );
  };

  const sections = [
    {
      title: "قوانین خرید و فروش (حقیقی)",
      content: `
        1. اصل کارت ملی جدید (در صورت نداشتن اصل کارت ملی جدید، اصل شناسنامه‌ جدید به همراه رسید درخواست کارت ملی جدید).<br />
        2. کارت بانکی به نام فرد خریدار یا فروشنده.<br />
        3. شماره تلفن همراه به نام شخص.<br />
        4. حضور شخص جهت تمامی امورات الزامی است.
      `,
    },
    {
      title: "مدارک مورد نیاز جهت خرید و فروش (حقوقی)",
      content: `
        1. اساسنامه.<br />
        2. آگهی ثبت شرکت.<br />
        3. روزنامه رسمی.<br />
        4. آگهی آخرین تغییرات.<br />
        5. معرفی نامه نماینده شرکت.<br />
        6. کارت ملی نماینده و شماره همراه.<br />
        7. گواهی مودیان مالیاتی.<br />
        8. کارت ملی مدیر عامل شرکت.<br />
        9. همراه داشتن مهر شرکت.<br />
        <strong>توجه:</strong> ریال مربوط به ارز و سکه خریداری شده و فروخته شده می‌بایست از طریق حساب شرکت واریز و پرداخت گردد.
      `,
    },
    {
      title: "قوانین جدید دریافت ارز مسافرتی",
      content: `
        1. ساعت فروش ارز در سامانه بله از ساعت 7 صبح الی 16 بعد از ظهر است.<br />
        2. در روزهای تعطیل امکان فروش ارز در سامانه بله وجود ندارد.<br />
        3. حداکثر 3 روز پیش از تاریخ پرواز امکان خرید ارز مسافرتی وجود دارد.<br />
        4. بعد از خرید ارز، حداکثر تا 4 روز امکان تحویل ارز توسط دستگاه خودپرداز وجود دارد.<br />
        5. در صورت تأخیر یا جا به جایی پرواز بیش از یک روز، امکان دریافت ارز وجود ندارد و لازم است جهت ابطال درخواست خود اقدام کنید.<br />
        6. دریافت ارز برای افراد زیر 18 سال مجاز نمی‌باشد.<br />
        7. جهت ابطال درخواست خود به شعب ارزی بانک ملی مراجعه کنید.
      `,
    },
    {
      title: "مراحل دریافت ارز مسافرتی در سامانه بله",
      content: `
        به منوی «خدمات» اپلیکیشن بله وارد شوید. سپس گزینه «ارز مسافرتی من» را انتخاب کنید.<br /><br />
        <strong>مرحله اول:</strong> ثبت مشخصات فردی (نام و نام خانوادگی، نام پدر، شمارۀ شناسنامه، کد ملی، کد پستی، شماره گذرنامه و تاریخ تولد).<br />
        <strong>مرحله دوم:</strong> وارد کردن اطلاعات فرودگاه و تاریخ پرواز.<br />
        <strong>مرحله سوم:</strong> انتخاب نوع و تعداد ارز.<br />
        <strong>مرحله چهارم:</strong> پرداخت مبلغ و دریافت شناسه فروش.<br />
        <strong>مرحله پنجم:</strong> مراجعه به باجه یا خودپرداز فرودگاهی برای دریافت ارز (باید کد ملی و شناسه فروش را در این مرحله ارائه کنید).
      `,
    },
  ];

  return (
    <div className="terms-conditions-page wide-page-margin">
      <div className="title">قوانین و شرایط استفاده از خدمات ما</div>
      <div className="terms-container">
        {sections.map((section, index) => (
          <div
            key={index}
            className={`topic ${
              expandedSections.includes(index) ? "expanded" : ""
            }`}
          >
            <div className="topic-inner flex justify-between items-center">
              <div className="sub-title">{section.title}</div>
              <div
                onClick={() => toggleSection(index)}
                style={{ cursor: "pointer" }}
              >
                <img src={expandDown} alt="Expand/Collapse" />
              </div>
            </div>
            {expandedSections.includes(index) && (
              <div className="content" dangerouslySetInnerHTML={{ __html: section.content }}></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermsConditionsPage;
